import PropTypes from "prop-types";
import { Navigate, useLocation } from "react-router-dom";
import LoadingScreen from "../components/loading-screen";
import { useAuthContext } from "./useAuthContext";

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default function AuthGuard({ children }) {
  const { isAuthenticated, isInitialized, user } = useAuthContext();
  const { pathname } = useLocation();

  if (!isInitialized) {
    return <LoadingScreen width="100px" height="100px" />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth/login" replace />;
  }

  if (!user) {
    return <LoadingScreen width="100px" height="100px" />;
  }

  if (user?.isProfileComplete === false) {
    return <Navigate to="/auth/sign-up" replace />;
  }

  if (!user?.permissions?.canViewDashboard) {
    if (pathname === "/dashboard") {
      return <Navigate to="/dashboard/pos" />;
    }
  }

  return <>{children}</>;
}
